import React from 'react';


export const LandingPartners = ({ navigate }) => (
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="mx-auto max-w-5xl">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-blue-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="font-heading text-3xl font-bold text-gray-900 mb-4">
                  Are You a Healthcare Provider?
                </h2>
                <p className="text-gray-600 mb-6">
                  Join MedRahi's network of 2,500+ doctors and 450+ hospitals. Connect with international patients and grow your practice globally.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center gap-2 text-sm text-gray-700">
                    <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                    Global patient reach from 50+ countries
                  </li>
                  <li className="flex items-center gap-2 text-sm text-gray-700">
                    <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                    Dedicated support & coordination
                  </li>
                  <li className="flex items-center gap-2 text-sm text-gray-700">
                    <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                    Free registration for verified providers
                  </li>
                </ul>
                <button
                  onClick={() => navigate('/partners')}
                  className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all"
                >
                  Learn More About Partnership →
                </button>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-2xl border border-blue-100 text-center">
                  <div className="text-4xl mb-2">🩺</div>
                  <div className="text-2xl font-bold text-blue-600">2,500+</div>
                  <div className="text-sm text-gray-600">Partner Doctors</div>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl border border-purple-100 text-center">
                  <div className="text-4xl mb-2">🏥</div>
                  <div className="text-2xl font-bold text-purple-600">450+</div>
                  <div className="text-sm text-gray-600">Partner Hospitals</div>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-2xl border border-green-100 text-center">
                  <div className="text-4xl mb-2">🌍</div>
                  <div className="text-2xl font-bold text-green-600">50+</div>
                  <div className="text-sm text-gray-600">Countries</div>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-2xl border border-orange-100 text-center">
                  <div className="text-4xl mb-2">⭐</div>
                  <div className="text-2xl font-bold text-orange-600">98%</div>
                  <div className="text-sm text-gray-600">Satisfaction</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
);
